import { httpsCallable } from 'firebase/functions';
import { functions } from '../lib/firebase';

// Initialize Firebase Functions (AI is active but CANNOT modify taxonomy levels 1-5)
const enhanceProductDescription = httpsCallable(functions, 'enhanceProductDescription');
const suggestPricingFactors = httpsCallable(functions, 'suggestPricingFactors');
const suggestProductCategories = httpsCallable(functions, 'suggestProductCategories');

export const smartQuoteService = {
  // Enhance product description using AI
  async enhanceDescription(quoteData) {
    try {
      console.log('Calling Firebase Function: enhanceProductDescription');
      const result = await enhanceProductDescription({ quoteData });
      
      if (result.data.success) {
        return result.data.enhancedDescription;
      } else {
        console.warn('AI enhancement failed, using fallback:', result.data.error);
        return result.data.fallbackDescription || null;
      }
    } catch (error) {
      console.error('Error calling enhanceProductDescription:', error);
      return null;
    }
  },

  // Get pricing factors suggestions
  async getPricingFactors(quoteData) {
    try {
      console.log('Calling Firebase Function: suggestPricingFactors');
      const result = await suggestPricingFactors({ quoteData });
      
      if (result.data.success) {
        return result.data.pricingFactors;
      } else {
        console.warn('Pricing factors failed, using fallback:', result.data.error);
        return result.data.fallbackFactors || null;
      }
    } catch (error) {
      console.error('Error calling suggestPricingFactors:', error);
      return null;
    }
  },

  // Suggest product categories from description
  async suggestCategories(description) {
    try {
      console.log('Calling Firebase Function: suggestProductCategories');
      const result = await suggestProductCategories({ description });
      
      if (result.data.success) {
        return result.data.suggestions;
      } else {
        console.warn('Category suggestions failed:', result.data.error);
        return null;
      }
    } catch (error) {
      console.error('Error calling suggestProductCategories:', error);
      return null;
    }
  },

  // Generate basic description (fallback without AI)
  generateBasicDescription(quoteData) {
    const parts = [];
    
    if (quoteData.style?.label) {
      parts.push(quoteData.style.label);
    }
    
    if (quoteData.materials && quoteData.materials.length > 0) {
      parts.push(`in ${quoteData.materials.join(' and ')}`);
    }
    
    // Add dimensions
    const dims = Object.entries(quoteData.dimensions || {})
      .filter(([_, value]) => value)
      .map(([key, value]) => `${key}: ${value}`)
      .join(', ');
    
    if (dims) {
      parts.push(`(${dims})`);
    }
    
    // Add features
    if (quoteData.features && quoteData.features.length > 0) {
      const featuresText = quoteData.features
        .map(f => f.replace(/_/g, ' '))
        .join(', ');
      parts.push(`with ${featuresText}`);
    }
    
    return parts.join(' ');
  }
};

export default smartQuoteService;